import {Component, ElementRef, EventEmitter, Inject, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DataFormatService} from "../../services/data-format.service";
import {DatePipe, PercentPipe} from "@angular/common";
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {FundService} from "../../funds/fund-service.service";
import {Apollo, QueryRef} from "apollo-angular";
import {certificated_outlets_search, deal_project_credits, get_project_credits} from "../../funds/graphql/getFunds";
import {
  activate_sequence,
  subscribe_to_sequence,
  update_status
} from "../../deals/deals-subcomponents/status-and-pipeline-dates/graphql/statusesAndSequences";
import {nav_search_funds} from "../../side-nav/cw-search/graphql/navSearchFunds";
import {debounceTime, distinctUntilChanged, Subscription} from "rxjs";
import {update_synd_notes} from "../../deals/deals-subcomponents/notes/graphql/alterNotes";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

@Component({
    selector: 'assignments-modal',
    templateUrl: './assignments-modal.component.html',
    styleUrls: ['./assignments-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssignmentsModalComponent implements OnInit{
  public projectCredits:any = {}
  public projectForms:{[key: string]: any[]} = {}
  public onSave:EventEmitter<any> = new EventEmitter<any>()
  public onRemove:EventEmitter<any> = new EventEmitter<any>()
  public onSubscribe:EventEmitter<any> = new EventEmitter<any>()
  public fundProjectStates:any[] = []
  public isLoaded = false;
  public projectDetails:any = {}
  public creditsArr:any[] = []
  private _certificatedOutlets:any[] = []
  public availableCredits:any[] = []
  public showAddCreditOutletSection = false;
  public querySubscription:Subscription;
  public project:any;
  public queryRef: QueryRef<any,any>;
  public statusControl: FormControl = new FormControl(null);
  public notesControl: FormControl = new FormControl(null)
  public searchResults: any[] = []
  public isCheckLoop: boolean = false;
  public ownershipWarning:string | null;
  public expandedFunds = new Set<string>()
  public addCreditForm: FormGroup = new FormGroup({
    outlet_type: new FormControl('fund'),
    outlet: new FormControl(null)
  })
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data:any, public dataFormat: DataFormatService, public datePipe: DatePipe, public fundService: FundService, private apollo: Apollo, private _snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.fundProjectStates = this.data.fundProjectStates;

    this._getDealProjectAssignments(this.data.projectId)
  }

  private _getDealProjectAssignments(id:string){
    this.queryRef = this.apollo.watchQuery({
      query: get_project_credits,
      fetchPolicy: 'no-cache',
      variables: {
        id: id
      }
    })
    this.querySubscription =  this.queryRef.valueChanges.subscribe((response:any) => {
      this.data.sequenceStatuses = [...this.data.sequenceStatuses].sort((a:any, b:any) => {
        let aDetailIndex = a.statusSequenceDetails.find((sequence:any) => sequence.statusSequence.name=='Syndications')
        let bDetailIndex = b.statusSequenceDetails.find((sequence:any) => sequence.statusSequence.name=='Syndications')
        return aDetailIndex.index - bDetailIndex.index
      });
      this._certificatedOutlets = response.data.certificatedOutlets;
      this.project = response.data.project
      this._setOutlets(response.data.project.projectCredits)
      this.creditsArr = response.data.project.projectCredits;
      let statusObject = this.data.sequenceStatuses.find((status:any) => status.name == this.data.status)
      this.statusControl.setValue(statusObject)
      this._setPanels();
      this.isLoaded = true;
      this.querySubscription.unsubscribe();
    })
  }

  private _setOutlets(outlets:any){
    let projectCredits:any[] = []
    let credits = []
    outlets.forEach((outlet:any) => {
      projectCredits.push(...outlet.projectCreditOutlets)
    })

    let projectCreditMap:any = {}
    let customOrder = ['Federal LIHTC', 'Federal Energy', 'Federal Historic', 'State LIHTC', 'State Energy', 'State Historic']
    let projOutlets = outlets.filter((outlet:any) => outlet.projectCreditOutlets.length > 0)
    projOutlets = projOutlets.length > 0 ? projOutlets : outlets.length > 0 ? outlets[0] : null
    let details:any = {
      project: this.project.name,
      projectDetailId: this.project.projectDetail.id,
      projecturl: this.dataFormat.formatLink(this.project),
      is_flagged: this.project.projectDetail.is_flagged_syndications,
      sponsor: this.project.sponsor[0]?.sponsor.name,
      sponsorurl: this.project.sponsor[0]?.sponsor ? this.dataFormat.formatLink(this.project.sponsor[0]?.sponsor) : null,
      status: null,
      project_status_id: this._fetchProjectStatus(this.project.projectStatuses)?.id,
      project_credit_id: this.project.projectCredits[0].id
    }
    this.projectDetails = details;
    if(projectCredits.length>0){
      for(let i = 0; i < projectCredits.length; i++){
        let outlet = projectCredits[i]
        let fund = projectCredits[i].fund!==null ? projectCredits[i].fund.name : projectCredits[i].certificatedOutlet !== null ? projectCredits[i].certificatedOutlet.organization?.name : null;
        let credit = projectCredits[i].projectCredit
        let loadWeight = projectCredits[i].fund!==null ? projectCredits[i].fund.non_certificated_load : projectCredits[i].certificatedOutlet !== null ? projectCredits[i].certificatedOutlet.certificated_load : 0
        let creditForm = new FormGroup({
          credit_id: new FormControl(credit.id),
          outlet_id: new FormControl(outlet.id),
          fund_id: new FormControl(projectCredits[i].fund!==null ? projectCredits[i].fund.id : projectCredits[i].certificatedOutlet !== null ? projectCredits[i].certificatedOutlet.organization?.id : null),
          credit_type: new FormControl(credit.taxCreditType.level + " " + credit.taxCreditType.name),
          gross_equity: new FormControl(this.fundService.setGrossEquity(outlet, credit, projectCredits[i].certificatedOutlet==null ? false : true, this._fetchProjectStatus(credit.project.projectStatuses)?.name)),
          estimated_gross_equity: new FormControl(outlet.estimated_gross_equity),
          notes: new FormControl(credit.project.projectDetail.syndications_notes),
          ppc: new FormControl(this.fundService.setPpc(credit.project, credit, outlet, this._fetchProjectStatus(credit.project.projectStatuses)?.name)),
          admitted_date: new FormControl(outlet.admitted_date == null ? null : new Date(outlet.admitted_date.split("-").join("/"))),
          exit_date: new FormControl(outlet.exit_date == null ? null : new Date(outlet.exit_date.split("-").join("/"))),
          revenue_year: new FormControl(outlet.revenue_year, [Validators.required]),
          is_target: new FormControl(outlet.is_target),
          is_target_exit: new FormControl(outlet.is_target_exit),
          ownership: new FormControl((outlet.ownership)),
          load: new FormControl(outlet.load_percentage !== null ? (outlet.load_percentage / .01) : null),
          ut_irr: new FormControl(outlet.ut_irr !== null ? (outlet.ut_irr / .01) : null),
          placement_status: new FormControl(outlet.fundProjectState.id),
          warehoused: new FormControl(outlet.warehoused),
          investor_approval_date: new FormControl(outlet.investor_approval_date == null ? null : new Date(outlet.investor_approval_date.split("-").join("/"))),
          projected_warehouse_days: new FormControl(outlet.projected_warehouse_days),
          loadWeight: new FormControl(loadWeight),
          is_target_investor_approval: new FormControl(outlet.is_target_investor_approval)
        }, {validators:this.dateValidator })
        if(projectCreditMap.hasOwnProperty(fund)){
          projectCreditMap[fund].push(outlet)
          this.projectForms[fund].push(creditForm)
          this.projectForms[fund].sort((a:any, b:any) => {
            let aIndex = customOrder.indexOf(a.value.credit_type)
            let bIndex = customOrder.indexOf(b.value.credit_type)
            if(aIndex === -1 && bIndex === -1){
              return a.value.credit_type.localeCompare(b.value.credit_type)
            } else if (aIndex === -1){
              return 1
            } else if (bIndex === -1){
              return -1;
            } else {
              return aIndex - bIndex
            }
          })
          //this.notesControl.setValue(this.project.projectDetail.syndications_notes)
        } else {
          projectCreditMap[fund] =[]
          projectCreditMap[fund].push(outlet)
          this.projectForms[fund] = []
          this.projectForms[fund].push(creditForm)
          this.projectForms[fund].sort((a:any, b:any) => {
            let aIndex = customOrder.indexOf(a.value.credit_type)
            let bIndex = customOrder.indexOf(b.value.credit_type)
            if(aIndex === -1 && bIndex === -1){
              return a.value.credit_type.localeCompare(b.value.credit_type)
            } else if (aIndex === -1){
              return 1
            } else if (bIndex === -1){
              return -1;
            } else {
              return aIndex - bIndex
            }
          })
          //this.notesControl.setValue(this.project.projectDetail.syndications_notes)
        }

      }

    }
    this.notesControl.setValue(this.project.projectDetail.syndications_notes)
    this.projectCredits = projectCreditMap
  }

  private _setPanels(){
    for(let k of Object.keys(this.projectForms)){
      let admittedForms = 0;
      this.projectForms[k].forEach((form:FormGroup) => {
        let placementValue = this.fundProjectStates.find((state:any) => state.id == form.value.placement_status)
        if(placementValue.name.toLowerCase() == 'admitted'){
          admittedForms += 1
        }
      })
      if(admittedForms !== this.projectForms[k].length){
        this.fundExpanded(k)
      }
    }
  }

  public save(){
    if(this.ownershipCheck()){
      this.ownershipWarning = 'Ownership percentage for deal exceeds 100%.'
      return;
    }

    if(this._isValidForms()){
      this._saveSyndicationsNotes()
      this.onSave.emit(this.projectForms)
    }
    this.ownershipWarning = null;
  }

  private _saveSyndicationsNotes(){
    if(this.notesControl.touched){
      this.apollo.mutate({
        mutation: update_synd_notes,
        variables: {
          id: this.projectDetails.projectDetailId,
          syndications_notes: this.notesControl.value
        }
      }).subscribe((response:any) => {})
    }
  }

  private _isValidForms(){
    let projectKeys = Object.keys(this.projectForms)
    for(let k = 0; k < projectKeys.length; k++){
      let forms = this.projectForms[projectKeys[k]];
      let hasInvalidForm = forms.filter((form:FormGroup) => !form.valid)
      if(hasInvalidForm.length>0){
        hasInvalidForm.forEach((form:FormGroup) => {
          form.controls['revenue_year'].markAsTouched()
        })
        return false;
      }
    }
    return true;
  }

  public ownershipCheck(){
    let projectKeys = Object.keys(this.projectForms)
    let typeTotals:any = {}
    for(let k = 0; k < projectKeys.length; k++){
      let forms = this.projectForms[projectKeys[k]]
      forms.forEach((form:any) => {
        typeTotals[form.value.credit_type] = (typeTotals[form.value.credit_type] || 0) + form.value.ownership
      })
    }
    let results = []
    for(let type in typeTotals){
      if(typeTotals[type]> 100){
        results.push(type)
      }
    }
    return results.length > 0
  }

  public headerStyle(creditType:string){
    let strings = creditType.split(" ");
    return 'row credit-type-header-' + strings[0].toLowerCase();
  }

  public onFieldChange(key:any, formcontrols: any, fieldKey:string){
    if(formcontrols.credit_type.value=='Federal LIHTC' || formcontrols.credit_type.value=='State LIHTC'){
      let copyVal = formcontrols[fieldKey].value;
      for(let i = 0; i < this.projectForms[key].length; i++){
        let controllevel = formcontrols.credit_type.value.split(" ")[0].toLowerCase();
        let formlevel = this.projectForms[key][i].value.credit_type.split(" ")[0].toLowerCase();
        if(formcontrols.credit_type.value!==this.projectForms[key][i].value.credit_type &&
        controllevel == formlevel){
          this.projectForms[key][i].controls[fieldKey].setValue(copyVal)

        }
      }
    }
  }

  public hasCreditSelected(form:any, credits:any[]){
    for(let cr of credits){
      let field = cr.tax_level + " " + cr.tax_name
      if(form.value[field]){
        return true;
      }
    }
    return false
  }

  public close(){
    this.dialogRef.close()
  }

  searchOutlets(event:any){
    let query = nav_search_funds
    this.addCreditForm.controls['outlet'].valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged() ).subscribe((value:any) => {
        if(typeof value == 'string' && this.addCreditForm.value.outlet_type=='fund'){
          this.apollo.watchQuery({
            query: query,
            variables: {
              searchLike: '%' + value + '%',
              search: value,
              limit: 10,
              page: 1,
            }
          }).valueChanges.subscribe((response:any) => {
            this.searchResults = response.data.search_funds.data
          })
        }
        if(typeof value == 'string' && this.addCreditForm.value.outlet_type == 'certificated'){
          this.searchResults = this._certificatedOutlets.filter((ot:any) => ot.organization.name.toLowerCase().includes(value.toLowerCase()))
        }
    });
  }

  public displayVal(option:any): string {
    if(option === null){
      return ''
    }
    if(typeof option === "string"){
      return option;
    }
    return option.organization ? option.organization.name : option.name

  }

  public dateValidator(form: AbstractControl):  ValidationErrors | null {
    const investorDate = form.get('investor_approval_date')?.value;
    const admittedDate = form.get('admitted_date')?.value;
    const investorIsTarget = form.get('is_target_investor_approval')?.value
    const admittedIsTarget = form.get('is_target')?.value

    return (investorIsTarget == admittedIsTarget) && investorDate && admittedDate && new Date(investorDate).getTime() > new Date(admittedDate).getTime() ? {invalidInvestorDate: true} : null
  }

  public subscribeToSequence(status_sequence_id: string){
    let inputVar = {
      project_id: this.project.id,
      status_sequence_id: status_sequence_id,
      is_primary: false,
      active: true
    }

    this.apollo.mutate({
      mutation: subscribe_to_sequence,
      variables: {
        input: inputVar
      }
    }).subscribe(({response}:any) => {
      this.openSnackBar('Project added to Syndications sequence', 'save-success')
      this.onSubscribe.emit()
    })
  }

  public unsubscribeToSequence(status_id: string){
    this.apollo.mutate({
      mutation: activate_sequence,
      variables: {
        id: status_id,
        active: false,
      }
    }).subscribe(({response}: any) => {})
  }


  public toggleSyndicationsFlag(){
    if(!this.data.status){
      let sequence = this.data.sequenceStatuses[0].statusSequenceDetails.filter((detail:any) => detail.statusSequence.name == 'Syndications')
      let sequence_id = null;
      if(sequence.length>0){
        sequence_id = sequence[0].status_sequence_id
      }
      this.subscribeToSequence(sequence_id)
    } else {
      let sequenceProjectStatus = this.project.projectStatuses.filter((status:any) => status.statusSequence.name == 'Syndications');
      let projectStatusId = sequenceProjectStatus[0].id
      this.unsubscribeToSequence(projectStatusId)
    }
  }

  public onStatusChange(event:any){
    let projectStatusId = this.projectDetails.project_status_id;
    let statusId = this.statusControl.value.id;
    let sequenceId = this.statusControl.value.statusSequenceDetails?.find((detail:any) => detail.statusSequence?.name === 'Syndications')?.status_sequence_id  ?? null
    if(!projectStatusId){
      this.subscribeToSequence(sequenceId)
      return;
    }
    this.apollo.mutate({
      mutation: update_status,
      variables: {
        id: projectStatusId,
        status_id: statusId,
        status_sequence_id: sequenceId
      }
    }).subscribe((response:any) => {
        this.openSnackBar('Status updated', 'save-success')
        this.onSubscribe.emit()
    })
  }

  public showHideAddCreditOutlet(){
    this.showAddCreditOutletSection = !this.showAddCreditOutletSection;
    if(this.showAddCreditOutletSection){
      for(let cr = 0; cr < this.creditsArr.length; cr++){
          if(this.creditsArr[cr].crea_syndicated){
            this.availableCredits.push({
              project_credit_id: this.creditsArr[cr].id,
              tax_credit_type_id: this.creditsArr[cr].taxCreditType.id,
              tax_designation_id: this.creditsArr[cr].taxCreditDesignation?.id,
              tax_level: this.creditsArr[cr].taxCreditType.level,
              tax_name: this.creditsArr[cr].taxCreditType.name,
              tax_designation_name: this.creditsArr[cr].taxCreditDesignation?.name,

            })
          }
      }
    } else {
      this.availableCredits = []
    }
    this.availableCredits = this.availableCredits.filter((value, index, self) => {
      let taxString = value.tax_level + " " + value.tax_name;
      return self.findIndex(i => i.tax_level + " " + i.tax_name == taxString) === index;
    });
    let creditOrder = ['Federal LIHTC', 'Federal Energy', 'Federal Historic', 'State LIHTC', 'State Energy', 'State Historic']
    this.availableCredits.sort((a:any,b:any) => {
      let aIndex = creditOrder.indexOf(a.tax_level + " " + a.tax_name)
      let bIndex = creditOrder.indexOf(b.tax_level + " " + b.tax_name)
      if(aIndex === -1 && bIndex === -1){
        let aName = a.tax_level + " " + a.tax_name
        let bName = b.tax_level + " " + b.tax_name
        return aName.localeCompare(bName)
      } else if (aIndex === -1){
        return 1
      } else if (bIndex === -1){
        return -1;
      } else {
        return aIndex - bIndex
      }
    })
    this.availableCredits.forEach((tcr:any) => {
      this.addCreditForm.addControl(tcr.tax_level + " " + tcr.tax_name, new FormControl(false))

    })
  }

  private _fetchProjectStatus(statuses:any[]){
    let foundStatus;
    foundStatus = statuses.find((status:any) => {
      return status.active && status.statusSequence.name == 'Syndications'
    })
    if(foundStatus){
      return {id: foundStatus.id, name: foundStatus.name}
    }
    return null
  }

  public removeFromSyndicationsSequence(){
    return true;
  }

  public enableField(credit:any, event:any){
    let level = credit.tax_level
    let name = credit.tax_name

    if(event.checked){
      let controlKeys = Object.keys(this.addCreditForm.controls)
      for(let k = 0; k < controlKeys.length; k++){
        if(!controlKeys[k].includes('LIHTC') && controlKeys[k].includes(level)){
          this.addCreditForm.controls[controlKeys[k]].setValue(true)
        }
      }
    }

  }


  public addCredit(event:any){
    let keys = Object.keys(event.value)
    let fundId = event.value.outlet.id
    let certificatedId = event.value.outlet.id
    let outletType = event.value.outlet_type
    let outletName = event.value.outlet.name ?? event.value.outlet.organization.name
    let unspecifiedStatus = this.fundProjectStates.find((state) => state.name == "Unspecified")

    for(let f = 0; f < keys.length; f++){
      if(keys[f]!=='outlet' && keys[f]!=='outlet_type' && event.value[keys[f]] == true){
        let credit = this.availableCredits.filter((arr:any) => {
          return (arr.tax_level + " " + arr.tax_name).toLowerCase() === keys[f].toLowerCase()})
        let creditId = credit.length ? credit[0].project_credit_id : null;
        let form = new FormGroup({
          credit_id: new FormControl(creditId),
          outlet_id: new FormControl(null),
          fund_id: new FormControl(outletType == 'fund' ? fundId : null),
          certificated_outlet_id: new FormControl(outletType == 'certificated' ? certificatedId : null),
          credit_type: new FormControl(keys[f]),
          gross_equity: new FormControl(null),
          estimated_gross_equity: new FormControl(null),
          notes: new FormControl(null),
          ppc: new FormControl(null),
          admitted_date: new FormControl(null),
          exit_date: new FormControl(null),
          revenue_year: new FormControl(null, [Validators.required]),
          is_target: new FormControl(true),
          is_target_exit: new FormControl(true),
          ownership: new FormControl(100),
          load: new FormControl(null),
          ut_irr: new FormControl(null),
          placement_status: new FormControl(unspecifiedStatus.id),
          warehoused: new FormControl(null),
          investor_approval_date: new FormControl(null),
          projected_warehouse_days: new FormControl(null),
          loadWeight: new FormControl(null),
          is_target_investor_approval: new FormControl(true)
        })
        if(this.projectForms.hasOwnProperty(outletName)){
          this.projectForms[outletName].push(form)
        } else {
          this.projectForms[outletName] = []
          this.projectForms[outletName].push(form)
        }

      }


    }
    /// collapse all and expand newly added credit
    let formKeys = Object.keys(this.projectForms)
    formKeys.forEach((key:string) => {
      if(this.expandedFunds.has(key)){
        this.expandedFunds.delete(key)
      }
      if(key === outletName){
        this.expandedFunds.add(key)
      }
    })
  }

  public defaultOrder(a:any,b:any){
    return 0
  }

  public fundExpanded(key:string){
    if(this.expandedFunds.has(key)){
      this.expandedFunds.delete(key)
    } else {
      this.expandedFunds.add(key)
    }
  }

  public removeCreditFromFund(project:any, key:string){
    let outletId = project.value.outlet_id;
    this.projectForms[key] = this.projectForms[key].filter((form:any) => {
      let projectLevel = project.value.credit_type.split(" ")[0]
      if(project.value.credit_type.includes('LIHTC')){
        if(!form.value.credit_type.includes(projectLevel)){
          return form
        }
      } else {
        return project !== form
      }
    })
    if(this.projectForms[key].length==0){
      delete this.projectForms[key]
    }
    if(outletId!==null){
      this.onRemove.emit(outletId)
    }
    this.queryRef.refetch().then((data:any) => {
      this.data.sequenceStatuses = [...this.data.sequenceStatuses].sort((a:any, b:any) => {
        let aDetailIndex = a.statusSequenceDetails.find((sequence:any) => sequence.statusSequence.name=='Syndications')
        let bDetailIndex = b.statusSequenceDetails.find((sequence:any) => sequence.statusSequence.name=='Syndications')
        return aDetailIndex.index - bDetailIndex.index
      });
      this._certificatedOutlets = data.data.certificatedOutlets;
      this.project = data.data.project
      this._setOutlets(data.data.project.projectCredits)
      this.creditsArr = data.data.project.projectCredits;
      let statusObject = this.data.sequenceStatuses.find((status:any) => status.name == this.data.status)
      this.statusControl.setValue(statusObject)
    })

  }

  private openSnackBar(message: string, panel_class:string) {
    const config = new MatSnackBarConfig();
    config.panelClass = panel_class !== null ? [panel_class] : ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open(message, 'Ok', config);
  }


  protected readonly Object = Object;
}
